import { Modal } from 'antd'
import styled from 'styled-components'

export const ContainerLista = styled.div`
  width: 100%;
  height: calc(100vh - 200px);
  gap: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  

  .card__header {
    width: 100%;
    height: 100%;
    display: flex;
    margin-bottom: 10px;
  }

  .header__infos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;

    div {
      background-color: #5d74d0;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      padding: 10px;
      font-size: 11px;
      font-weight: bold;
      color: white;
    }

    p {
      font-size: 14px;
      font-weight: bold;
      color: #5d74d0;
      margin: 0;
      padding: 0;
    }
  }

  .header__infos__buttons {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 5px;
  }
`

export const CardListar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid #e1e1e1;
  border-radius: 7px;
  padding: 10px;

  .detalhes__analise {
    width: 100%;

    h3 {
      color: #757575;
      font-size: 13px;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .info__detalhes {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .detalhes {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .detalhes:is([data-active='true']) {
      padding: 10px;
      display: flex;
      flex-direction: column;
      background-color: #f6ffed;
      color: #5da57d;
      border-radius: 5px;
    }
  }

  .detalhes__observacao {
    width: 100%;
    padding-top: 10px;
    display: flex;
    flex-direction: column;

    span {
      color: #757575;
      font-size: 13px;
      font-weight: 700;
    }

    p {
      margin: 0;
      padding: 0;
    }
  }
`

export const ContainerPontos = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 10px;

  .points-title {
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .points-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 35px);
    gap: 10px;
  }

  .point-card {
    background-color: #eef2ff;
    color: white;
    font-weight: 700;
    font-size: 15px;
    min-width: 35px;
    height: 35px;
    border-radius: 8px;
    position: relative;
    cursor: default;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    transition: opacity 0.2s;
  }

  .point-card:hover {
    opacity: 0.85;
  }

  .point-card__remove {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #ff4d4f;
    color: white;
    border: 2px solid white;
    font-size: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transform: scale(0.5);
    transition: opacity 0.15s ease, transform 0.15s ease;
    pointer-events: none;
    padding: 0;
    line-height: 1;
  }

  .point-card:hover .point-card__remove {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }

  .point-card__remove:hover {
    background-color: #cf1322;
  }

  .add-button {
    background-color: transparent;
    border: 2px solid #6abf8e;
    color: #6abf8e;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
  }

  .add-button:hover {
    background-color: #f0fdf4; /* Verde muito claro ao passar o mouse */
  }
`
export const ModalCopiaAnalises = styled(Modal)`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 100px;
  right: 30px;
  z-index: 9999;

  .ant-modal-content {
    padding: 0;
  }

  .titulo__modal {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }

  .body__modal {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
`